import '../../css/mk-brand.css';

import {useState, useEffect} from "react";



function Panel() {
    useEffect(() => {}, );
    return (
        <div id="culinary-missions" className="m-2">
            <div className="container bg-zinc-800 pt-4 px-4 pb-4 rounded-lg max-w-4xl">
            <div className="flex flex-row justify-center">
                <h2 className="text-3xl md:text-6xl text-white">Culinary</h2>
                <h2 className="text-3xl md:text-6xl text-brand">&nbsp;</h2>
                <h2 className="text-3xl md:text-6xl text-brand">Missions</h2>
            </div>
            <div className="text-brand-text text-2xl text-right cursor-pointer hover:font-bold">
                <a href="https://metakitchen.gitbook.io/metakitchen-wp/wb1pN4vYLKsa8w4IX5qL/roadmap/culinary-missions">
                    staking-game
                </a>
            </div>
            <div className="border border-brand" />
            <br className="w-1/2"/>
            <div className="flex flex-wrap items-center justify-center w-full">
                <div className="flex flex-row overflow-hidden bg-zinc-200 rounded-lg border border-black border-2 hover:scale-105 text-black hover:text-brand-text hover:text-lg hover:bg-zinc-500">
                    <div className="flex flex-row  items-center w-32 p-10 bg-brand ">
                        <span className="font-extrabold">Kitchen Prep</span>
                    </div>
                    <div className="p-2 font-bold">
                        <p>
                            Your OG Chefs will have to be staked in the metaKitchen terminal to start earning $CHEF rewards. Accumulate $CHEF tokens wisely to maximize your pantry. The rarity and quantity of OG chefs staked will impact $CHEF staking rewards.
                            The higher the stars the higher the multiplier.
                        </p>
                    </div>
                </div>
                <div className="h-8" />
                <div className="flex flex-row overflow-hidden bg-zinc-200 rounded-lg border border-black border-2 hover:scale-105 text-black hover:text-brand-text hover:text-lg hover:bg-zinc-500">
                    <div className="flex flex-row items-center w-32 p-10 bg-brand ">
                        <span className="font-extrabold ">$CHEF Utility</span>
                    </div>
                    <div className="p-2 font-bold">
                        <p>
                            $CHEF will be the ecosystem's currency for unlocking the metaKitchen. It will allow you to mint our future in game character - the metaChef.
                            It will also be used to bid on Ingredients and Utensil NFT's, all three will have various degrees of rarity and utility.
                        </p>
                    </div>
                </div>
                <div className="h-8" />
                <div className="flex flex-row overflow-hidden bg-zinc-200 rounded-lg border border-black border-2 hover:scale-105 text-black hover:text-brand-text hover:text-lg hover:bg-zinc-500">
                    <div className="flex flex-row items-center w-32 p-10 bg-brand">
                        <span className="font-extrabold">Culinary Missions</span>
                        <div className="flex items-center">
                        </div>
                    </div>
                    <div className="p-2 font-bold">
                        <ul>
                            <p className=""> To gain experience, learn new skills, and find recipes metaChefs will need to complete missions.
                                Ingredients will bring utility to your missions providing buffs like: Mission success rate (based on rarity), decreased fatigue, XP multipliers.
                                Utensils will grant: Extra time on the clock, special stat bonuses awarded from mission and % chance of winning from $CHEF reward pools.

                            </p>
                        </ul>
                    </div>
                </div>
            </div>
            </div>
        </div>
    );
}

export default Panel;
